module.exports = __webpack_public_path__ + "static/media/eva_car_people.cae3ae97.png";